var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAva(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2H2V0H0V2ZM0 6H2V4H0V6ZM6 18H4V16H6V18ZM4 10H6V8H4V10ZM2 10H0V8H2V10ZM0 18H2V16H0V18ZM2 14H0V12H2V14ZM4 2H6V0H4V2ZM18 14H16V12H18V14ZM8 18H10V0H8V18ZM18 18H16V16H18V18ZM16 10H18V8H16V10ZM16 2V0H18V2H16ZM16 6H18V4H16V6ZM14 2H12V0H14V2ZM12 18H14V16H12V18ZM14 10H12V8H14V10Z",
    fill: "#1E90FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAva);
export default __webpack_public_path__ + "static/media/AVA.6a447c17b0693c1eefda7e43e9dd6bb2.svg";
export { ForwardRef as ReactComponent };